// React
import React, {useState} from "react";
// Redux imports
import { useSelector, useDispatch } from "react-redux";
import { setProyecto } from "../../../redux/reducers/proyectos";
import { resetDataVestuarioTallaje } from "../../../redux/reducers/vestuario";

import ActionBar, {
  Action,
  ActionGroup,
  // BottomActionGroup
} from 'calcite-react/ActionBar';

// Styled Components
import styled from "styled-components";

const ActionBarLeft = styled.div`
  // float:left;
  // display: inline-flex;
  // position: relative;
  // width: auto;
  // height: 100%;
  // text-align: center;
  // z-index: 2;
  // left: 0px;
  overflow: hidden;
  // background-color: #4c4c4c;
  // color: #fff;
`;

const ItemMenuOptsIcon = styled.div`
  width: 16px;
  height: 16px;
  background: transpararent;
  font-size:0.95rem;
  font-weight:700;
  text-align: center;
`;

const MenuLeftVestuario = props => {
    // const isCollapsed = useSelector(state => state.proyectos.collapsed);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const activeAction = useSelector(state => state.proyectos.activeProyecto);
    const listBenefTallaje = useSelector(state => state.vestuario.listBenefTallaje);
    const dispatch = useDispatch();

    const proyectosNames = {
      "":'Caracterización Social y Económica',
      "COTIZACION_VESTUARIO": "Cotización",
      "TALLAJE_VESTUARIO": "Tallaje",
      "ENTREGA_VESTUARIO": "Entrega",
      "CONFIGURACION": "Configuración del GRB", 
    };

    // useEffect(() => {
    //   dispatch(moduleLEFTPANELLoaded({activeModule:activeAction, headerTitle:proyectosNames[activeAction]}));
    // }, [dispatch]);

    const onToggleCollapse = (e) => {
      setIsCollapsed(!isCollapsed);
    };

    const turnOffModules = () => {
      // dispatch(moduleUSERSLoaded({loaded:false})); // Hide Users
      // dispatch(moduleBENEFICIARIOSLoaded({loaded:false}));
    }


    const actionSelected = (activeAction) => {
      dispatch(setProyecto({activeProyecto:activeAction, collapsed:isCollapsed, headerTitle:proyectosNames[activeAction]}));
      turnOffModules();
      switch (activeAction) {
        case 'COTIZACION_VESTUARIO':
          console.log('COTIZACION_VESTUARIO');
          break;
        case 'TALLAJE_VESTUARIO':
          if (listBenefTallaje && listBenefTallaje.length>0){
            dispatch(resetDataVestuarioTallaje({listBenefTallaje:[]}));
          }
          break;
        case 'ENTREGA_VESTUARIO':
          console.log('ENTREGA_VESTUARIO');
          break;
        default:
          break;
      }
    };

    return (
      <ActionBarLeft>
      <ActionBar 
        // showCollapser={false}
        collapseLabel='Ocultar' 
        expandLabel='Expandir' 
        collapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      >
        <ActionGroup>
          <Action
            onClick={() => actionSelected('COTIZACION_VESTUARIO')}
            active={activeAction === 'COTIZACION_VESTUARIO'}
            icon={<ItemMenuOptsIcon>C</ItemMenuOptsIcon>}
          >
            Cotización
          </Action>
          <Action 
              onClick={() => actionSelected('TALLAJE_VESTUARIO')}
              active={activeAction === 'TALLAJE_VESTUARIO'}
              icon={<ItemMenuOptsIcon>T</ItemMenuOptsIcon>}
            >
              Tallaje
          </Action>
        <Action
          onClick={() => actionSelected('ENTREGA_VESTUARIO')}
          active={activeAction === 'ENTREGA_VESTUARIO'}
          icon={<ItemMenuOptsIcon>E</ItemMenuOptsIcon>}
          >Entrega
        </Action>
        </ActionGroup>
        {/* <BottomActionGroup>
        <Action icon={<GearIcon />}>Configuración</Action>
      </BottomActionGroup> */}
      </ActionBar>
      </ActionBarLeft>
    )

}

export default MenuLeftVestuario;